module.exports = __webpack_public_path__ + "img/LogoDashboard-18.82866c02.svg";